//react
import { useState, useRef } from 'react';

//bootstrap
import { Alert } from 'react-bootstrap';

//stripe
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';

//spotsync
import { SubscribeInitResp, SubscribeInviteInitResp } from "./Data/ApiTypes";
import { showMoney } from "./Data/Money";
import { Button } from "./Controls/Button";
import { connectUrl } from './Data/WebUrl';
import { PageMaskOpts, maskAtom } from './Data/Atoms';
import { useAtom } from 'jotai';     
import { createApiService } from './shared/apiConfig';
import { WaitlistApi } from './shared/api/axios-client';
import { toast } from 'react-toastify';

const scrollDownOnElementLoaded = (formRef: React.RefObject<HTMLFormElement>) => {
    setTimeout(() => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }, 100);
};

type CheckoutFormProps = {
    subscribeInitResp: SubscribeInitResp | SubscribeInviteInitResp;
    waitlistEntryId?: number;
}

export function StripeMonthlyCheckoutForm({ subscribeInitResp, waitlistEntryId = 0 }: CheckoutFormProps) {
    const stripe = useStripe();
    const elements = useElements();
    const [msg, setMsg] = useState<string>();
    const [isProcessing, setIsProcessing] = useState(false);
    const formRef = useRef<HTMLFormElement>(null);

    const waitlistApi = createApiService(WaitlistApi);

    const maskOptions: PageMaskOpts = {
        showMask: true,
        header: <div className="h2">Processing Payment</div>,
        subText: 'Do not close your browser',
    };

    const [, setShowMask] = useAtom(maskAtom);
    
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        //trigger form validation and wallet collection
        const { error: submitError } = await elements.submit();
        if (submitError) {
            return;
        }

        setShowMask(maskOptions);

        if (waitlistEntryId && waitlistEntryId > 0)
        {
            try {
                const result = await waitlistApi.setWailitEntryAsAccepted({
                    id: waitlistEntryId
                });

                if (result.data.error) {
                    toast.error(result.data.error);
                    return;
                }
                } catch {
                toast.error("An unexpected error occurred. Please try again later.");
            }
        }

        const result = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: connectUrl("/paid"),
            },
        });

        if (result.error) {
            setMsg(result.error.message);
        }

        setShowMask(undefined);
    };

    return <form ref={formRef} onSubmit={handleSubmit}>
        <PaymentElement onReady={() => {
            scrollDownOnElementLoaded(formRef);
        }} />
        <div className="d-flex justify-content-end">
            <Button type="submit" disabled={!stripe} className="mt-3 px-3 btn-main">
                Pay {showMoney(subscribeInitResp.price)} for {subscribeInitResp.quantity} spots
            </Button>
        </div>
        <br />
        {msg && <Alert variant="danger">
            {msg}
        </Alert>}
    </form>
}; 